import { SITE_COPY } from '@lifetimeline/shared';

/**
 * 서비스 **주소** 표기 — 한곳에 모아둔다.
 *
 * ⚠️ 여기 있는 것은 이름이 아니라 **도메인**이다. 로고에 찍히는 이름은
 * i18n의 `common.appName`(`LATARA`)이고, 둘은 이제 다르다.
 *
 * 프로필 주소는 사람이 눌러 들어가는 진짜 주소라, 도메인이 바뀌기 전에는
 * 여기 값이 바뀌면 안 된다 — 이름이 정해졌다고 주소까지 같이 고치면
 * 나눠 준 링크가 전부 죽는다.
 */

/**
 * 주소를 **적어 넣는 칸**에 붙이는 앞부분.
 *
 * 여기에는 `https://`를 안 붙인다 — 가입·설정에서 아이디 칸 앞에 붙는 값이라,
 * 길어지면 좁은 화면에서 정작 적을 칸이 사라진다. 적는 자리는 "어디에 생기나"만
 * 알려주면 된다.
 */
export const PROFILE_URL_PREFIX = 'life-timeline.com/@';

/**
 * **보여주는** 주소의 앞부분.
 *
 * 이쪽에는 `https://`를 붙인다 — 복사해 나르는 진짜 주소다.
 *
 * ⚠️ 프로필 **화면 상단**은 이걸 안 쓴다(`profileHandle`). 거기서는 도메인이
 * 줄의 대부분을 먹는데, 그 자리에서 알아야 할 것은 "어느 사이트냐"가 아니라
 * **누구냐**다 — 이미 그 사이트를 보고 있다. 풀 주소가 필요한 자리는
 * 공유 카드 바닥처럼 **사이트 밖으로 나가는** 곳이다.
 */
const PROFILE_URL_DISPLAY_PREFIX = `https://${PROFILE_URL_PREFIX}`;

/**
 * 영어권에 쓰는 이름.
 *
 * ⚠️ 로고(`common.appName` = LATARA)와 **일부러 다르다.** `LATARA`는
 * `라이프 타임라인`의 앞 글자를 딴 말이라 한국어에서만 읽힌다. 영어로 열면
 * 그 말놀이가 안 보이므로, 이름이 놓이는 자리에는 **무엇을 하는 곳인지**가
 * 읽히는 이 이름을 쓴다. 도메인(`life-timeline.com`)과도 같은 말이다.
 *
 * 탭 제목과 홈의 이름 줄이 **이 값 하나**를 본다 — 두 곳에 따로 적어 두면
 * 한쪽만 고쳐져 서비스 이름이 화면마다 달라진다.
 */
export const ENGLISH_NAME = SITE_COPY.en.siteName;

/**
 * 문의받는 주소. 바닥글에 **주소 그대로** 걸어 둔다.
 *
 * "문의하기" 같은 라벨을 붙이지 않는다 — 이메일 주소는 그 자체로 무엇인지
 * 말한다. 폼을 만들지 않는 이유도 같다. 폼은 서버·저장소·스팸 대응이 딸려
 * 오는데, 지금 오는 말은 "이게 안 돼요" 몇 줄이라 메일이면 충분하다.
 *
 * ⚠️ 주소가 페이지에 그대로 있으니 **수집 봇에 긁힌다.** 자바스크립트로
 * 가리는 방법도 있지만, 그러면 스크립트가 안 뜬 사람에게는 문의할 길이
 * 사라진다. 막을 수 있는 것보다 막히는 사람이 더 아깝다.
 */
export const CONTACT_EMAIL = 'zzundi.studio@gmail.com';

/** `https://life-timeline.com/@junho` — 사이트 **밖으로** 나가는 자리에 쓴다 */
export function profileUrl(handle: string): string {
  return `${PROFILE_URL_DISPLAY_PREFIX}${handle}`;
}

/** `@junho` — 프로필 상단처럼 이미 사이트 안인 자리에 쓴다 */
export function profileHandle(handle: string): string {
  return `@${handle}`;
}

/**
 * 프로필 탭 제목은 **서버와 같은 함수**를 쓴다 — API가 프로필 HTML에 박아
 * 내려주는 `<title>`과 화면이 그린 뒤의 제목이 달라지면 안 된다.
 */
export { profileDocumentTitle } from '@lifetimeline/shared';
